/*
 *  @providesModule LTOModalStyle
 *  
 */

/* eslint-disable no-magic-numbers */

import SkillzStyle from 'SkillzStyle';
import Sizes from 'Sizes';

import {
  StyleSheet, Platform,
} from 'react-native';


const {
  textColorSecondary,
  fontSizeH1,
  fontSizeH2,
  fontSizeH3,
  fontSizeH4,
  fontSecondary,
  btnTextColorOne,
  btnGradientStore,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({

  modalContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
  },

  buttonContainer: {
    width: Sizes.select({
      phone: '93%',
      tablet: '92%',
    }),
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 20,
    marginTop: 15,
    marginHorizontal: Sizes.select({
      phone: 10,
      tablet: 15,
    }),
  },

  pushButtonText: {
    ...fontSizeH4,
    ...fontSecondary,
    ...btnTextColorOne,
  },

  buttonLayout: {
    flexGrow: 1,
    marginHorizontal: 5,
    maxHeight: Sizes.select({
      phone: 35,
    }),
    width: '45%',
  },

  title: {
    ...fontSecondary,
    ...btnTextColorOne,
    ...Sizes.select({
      smallPhone: fontSizeH4,
      largePhone: fontSizeH3,
      tablet: fontSizeH2,
    }),
    backgroundColor: 'transparent',
    textAlign: 'center',
    padding: 7,
  },

  gradient: {
    backgroundColor: btnGradientStore[0],
    borderColor: btnGradientStore[0],
    marginTop: 15,
    flexGrow: 1,
    ...Platform.select({
      ios: {
        borderRadius: 4,
        borderWidth: Sizes.select({
          tablet: 3,
          phone: 2.5,
        }),
      },
      android: {
        borderRadius: 2,
        borderWidth: Sizes.select({
          phone: 3,
          tablet: 4,
        }),
      },
      web: {
        borderRadius: 4,
        borderWidth: Sizes.select({
          tablet: 3,
          phone: 2.5,
        }),
      },
    }),
  },

  gradientText: {
    ...fontSecondary,
    fontSize: Sizes.select({
      phone: 40,
      tablet: 42
    }),
    gradientColors: btnGradientStore,
    textAlign: "center",
    ...Platform.select({
      web: {
        color: btnGradientStore[1],
      },
    }),
  },

  plusContainer: {
    ...Platform.select({
      ios: {
        ...Sizes.select({
          phone: {
            marginTop: -5,
            marginHorizontal: 5,
            maxHeight: Sizes.screenWidth * 0.2,
          },
          tablet: {
            marginTop: -10,
            marginHorizontal: 10,
            maxHeight: Sizes.screenWidth * 0.12,
          }
        }),
      },
      web: {
        ...Sizes.select({
          phone: {
            marginTop: -5,
            marginHorizontal: 5,
            maxHeight: Sizes.screenWidth * 0.2,
          },
          tablet: {
            marginTop: -10,
            marginHorizontal: 10,
            maxHeight: Sizes.screenWidth * 0.12,
          }
        }),
      },
      android: {
        marginTop: -5,
        ...Sizes.select({
          phone: {
            marginHorizontal: 6,
            maxHeight: Sizes.screenWidth * 0.2,
          },
          tablet: {
            marginHorizontal: 10,
            width: Sizes.screenWidth * 0.095,
            maxHeight: Sizes.screenWidth * 0.14,
          }
        })
      },
    }),
    flexDirection: 'column',
    justifyContent: 'center',
  },

  bodyMargins: {
    marginTop: 10,
    marginBottom: 5,
  },

  bodyText: {
    ...Sizes.select({
      phone: fontSizeH2,
      tablet: fontSizeH1,
    }),
    ...fontSecondary,
    ...textColorSecondary,
    textAlign: 'center',
  },

  borderContainer: {
    backgroundColor: '#fff',
    width: '90%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 15,
  },

  contentContainer: {
    backgroundColor: '#fff',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1,
    ...Platform.select({
      android: {
        borderRadius: 2,
        borderColor: '#fff',
      },
    }),
  },

  offerContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    ...Sizes.select({
      phone: {
        height: Sizes.screenWidth * 0.2,
        marginHorizontal: 5,
      },
      tablet: {
        marginHorizontal: 15,
        height: Platform.select({
          ios: Sizes.screenWidth * 0.12,
          android: Sizes.screenWidth * 0.14,
          web: Sizes.screenWidth * 0.14,
        }),
      }
    }),
    ...Platform.select({
      web: {
        alignItems: 'stretch',
        width: '100%'
      },
    }),
  },

  countdownContainer: {
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: Sizes.select({
      phone: 4,
      tablet: 8,
    }), 
    marginBottom: Sizes.select({
      phone: 5,
      tablet: 10,
    }),
  },

  countdownTimeText: {
    ...Sizes.select({
      phone: fontSizeH3,
      tablet: fontSizeH2,
    }),
    ...textColorSecondary,
  },
});
